"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 * This hook takes in a React object ref and returns a [callback
 * ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) that will
 * update the object ref when called. This is helpful when trying to pass a
 * single ref to different APIs that require different ref types.
 *
 * @param {React.RefObject<*>} - A React object reference.
 *
 * @returns {React.Ref<*>} - A React callback reference.
 */
var useCallbackRef = function useCallbackRef(objectRef) {
  return (0, _react.useCallback)(function (element) {
    if (element) {
      objectRef.current = element;
    }
  }, [objectRef]);
};

var _default = useCallbackRef;
exports["default"] = _default;